export const PROJECT_EMBED_CONFIG = {
    name        : 'Embed View',
    icon        : 'i5-embeded-code', //'i5-sticky-note',
    iconSvg     : 'isvg-embed',
    url         : 'embed',
    description : 'Embed any web content',
    inheritance : false,
    projectIcon : 'embed',
}
